<template>
    <div v-if="!loading && !error && categories.length > 0">
        <h2 v-if="title" class="tagged-news__title tagged-news__title--blue">
            {{ title }}
        </h2>
        <div class="tagged-news__filters" v-if="categories.length > 1">
            <button class="tagged-news__filter-button" :class="{
                'tagged-news__filter-button--active': activeCategory.title === category.title
            }" v-for="(category, index) in categories" :key="index" v-on:click="handleCategoryChange(category)">
                {{ category.title }}
            </button>
        </div>
        <div class="tagged-news__container" v-if="activeCategory">
            <div class="tagged-news__section">
                <a :href="item.url" class="tagged-news" v-for="(item, index) in activeCategory.articles.slice(0, 2)"
                    :key="`left-${index}`">
                    <div class="tagged-news__content">
                        <h3 class="tagged-news__title">{{ item.title }}</h3>
                    </div>
                    <div class="tagged-news__meta"><span>{{ item.category }}</span><span>{{ item.published }}</span></div>
                </a>
            </div>
            <div class="tagged-news__section">
                <a :href="item.url" class="tagged-news" v-for="(item, index) in activeCategory.articles.slice(2, 5)"
                    :key="`right-${index}`">
                    <div class="tagged-news__content">
                        <h3 class="tagged-news__title">{{ item.title }}</h3>
                    </div>
                    <div class="tagged-news__meta"><span>{{ item.category }}</span><span>{{ item.published }}</span></div>
                </a>
            </div>
        </div>
        <div class="news-block__grid" v-if="activeCategory">
            <div class="news-block__grid-wrapper">
                <a v-for="(article, index) in activeCategory.articles.slice(5, activeCategory.show)"
                    :key="index + '-regular'" :href="article.url" class="news-block__grid-item">
                    <div class="news-block__grid-meta"><span>{{ article.published }}</span></div>
                    <h3 class="news-block__grid-title">{{ article.title }}</h3>
                </a>
            </div>
        </div>
        <div class="news-block__button" v-if="activeCategory && activeCategory.articles.length > activeCategory.show">
            <button @click="loadMore" :disabled="activeCategory.articles.length <= activeCategory.show" class="button">{{
                loadingMore ? "Loading..." : "See More" }}</button>
        </div>
    </div>
</template>

<script>
import axios from 'axios';


export default {
    props: ["title", "documentType", "documentId", "culture"],
    data() {
        return {
            error: false,
            loading: true,
            loadingMore: false,
            content: [],
            categories: [],
            activeCategory: null,
        }
    },
    mounted() {
        this.getRelatedContent();
    },
    watch: {
        categories() {
            if (this.categories.length === 0) {
                document.querySelector("[data-tab='news']").style.display = "none";
            } else {
                let newCategories = this.categories;
                newCategories.forEach((e) => {
                    e.show = 5;
                })
                this.categories = newCategories;
                document.querySelector("[data-tab='news']").style.display = "flex";
            }
        }
    },
    methods: {
        loadMore: function () {
            this.activeCategory.show = this.activeCategory.show + 8;
        },
        handleCategoryChange: function (category) {
            const urlParams = new URLSearchParams(window.location.search);
            const stateParam = urlParams.get('tab');
            let newUrl = `${window.location.origin}${window.location.pathname}?subtab=${encodeURIComponent(category.title)}&tab=${stateParam}`;
            if (history.pushState) {
                history.pushState({}, "", newUrl);
            }
            this.activeCategory = category
        },
        getRelatedContent: function () {
            axios.post(`/api/news/${this.documentType}/${this.documentId}?culture=${this.culture}`, {
                tags: this.tags
            }, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            })
                .then((response) => {
                    this.categories = response.data;

                    if (!this.activeCategory) {
                        this.activeCategory = this.categories[0]
                    }

                    const urlParams = new URLSearchParams(window.location.search);
                    const stateParam = urlParams.get('subtab');
                    if (stateParam) {
                        let matchingCategory = this.categories.filter((e) => {
                            return e.title === decodeURIComponent(stateParam);
                        });
                        if (matchingCategory.length > 0) {
                            this.activeCategory = matchingCategory[0]
                        }
                    }

                    this.loading = false;
                    this.loadingMore = false;
                })
                .catch((err) => {
                    this.error = true;
                    this.loading = false;
                    this.loadingMore = false;
                });
        }
    }
}
</script>

